// extracted by mini-css-extract-plugin
export var group = "styles-module--group--94432";
export var groups = "styles-module--groups--e0f76";
export var header = "styles-module--header--2b65d";
export var range = "styles-module--range--1104a";
export var script = "styles-module--script--a9847";
export var square = "styles-module--square--b87ce";
export var subtext = "styles-module--subtext--b6267";
export var wrapper = "styles-module--wrapper--fb63c";